<!--
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2024-03-14 09:53:47
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2024-10-16 09:32:01
 * @FilePath: \hxt-saas-pc\src\views\xx.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template id="temp">
    <!-- vue实例外创建 -->
    <div class="content"><br>
        <div class="Mask" v-show="show" @click="show = false"></div>
        <div class="tab">
            <div :id="item.id == 'special-subject' ? 'ztxx' : ''" @click="setActive(item)"
                :class="tabActive == item.id ? 'active tab-list' : 'tab-list'" v-for="item in tabList " :key="item.id">{{
                    item.label }}
                <!-- <div class="new" v-if="item.id == 'special-subject'"> NEW</div> -->
                <div @click="show = false" v-show="show" class="ts" v-if="item.id == 'special-subject'">
                    专题学习
                    <div class="ts-zy"><img src="../assets/img/zy.png" alt=""></div>
                    <div class="ts-text">为提供更专业有效的学习，现已为用户 新增了“专题学习”模块，快去看看吧~~</div>
                </div>
            </div>
        </div>
        <div class="content-box" v-if="tabActive == 'live-learn'">
            <LiveLearn></LiveLearn>
        </div>
        <div class="content-box" v-if="tabActive == 'record-learn'">
            <RecordCourse></RecordCourse>
        </div>
        <div class="content-box" v-if="tabActive == 'special-subject'">
            <ztxx />
        </div>
    </div>
</template>
<!-- 调用   <mycom></mycom> -->
<script>
import LiveLearn from '@/views/MyRights/components/LiveLearn.vue';
import RecordCourse from '@/views/MyRights/components/RecordCourse.vue'
import ztxx from '@/views/MyRights/components/ztxx.vue';
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
export default {
    components: { LiveLearn, RecordCourse, ztxx },
    data() {
        return {
            show: false,
            tabActive: localStorage.getItem('tabActive') ? localStorage.getItem('tabActive') : "record-learn",
            tabList: [

                {
                    id: 'record-learn',
                    label: '课程学习'
                }, {
                    id: 'live-learn',
                    label: '直播学习'
                },
                {
                    id: 'special-subject',
                    label: '专题学习'
                },
            ]
        }
    }, mounted() {
        // if (!localStorage.getItem('isShowHelp')) {

        //     this.show = true

        //     localStorage.setItem('isShowHelp', 1)

        // }


    },
    methods: {
        setActive(row) {
            this.tabActive = row.id
            localStorage.setItem('tabActive', row.id)
        }
    },
}
</script>

<style scoped>
.Mask {
    left: 0;
    top: 0;
    position: absolute;
    width: 100%;
    height: 150%;
    background: rgba(0, 0, 0, 0.69);
    z-index: 100;
}

.content {
    margin-top: 10px;
    width: 100%;
    min-height: 800px;
    background: #fff;
}

.tab {

    width: 1200px;
    height: 30px;
    margin: 0 auto;
    margin-bottom: 10px;
    display: flex;
}

.tab-list {

    line-height: 29px;
    width: 86px;
    height: 29px;

    border-radius: 14px;

    font-size: 14px;
    text-align: center;
    cursor: pointer;
    position: relative;


}

.ts {
    position: absolute;
    left: 0;
    top: -30px;
    width: 100px;
    height: 80px;
    background: #fff;
    border-radius: 50%;
    z-index: 100;
    line-height: 88px;
}

.ts-zy {
    margin-left: 100px;
}

.ts-text {
    width: 280px;
    height: 50px;
    color: #fff;
    line-height: 20px;
    margin-left: 200px;
}

.new {
    right: -8px;
    top: -12px;
    position: absolute;
    width: 34px;
    height: 14px;
    background: #FF8B4E;
    color: #fff;
    border-radius: 10px;
    font-size: 11px;
    line-height: 16px;
    z-index: 101;

}

.tab>.active {
    background: #F7F7F7;
    border-radius: 14px;
    color: rgba(15, 108, 245, 1);
    font-size: 16px;
}

.content-box {
    width: 100%;
    height: auto;
    margin-top: 20px;
    background: #fff;
}
</style>